import axios from 'axios'
import { SALES_ENDPOINT } from '../../endpoints'

export async function changeState(id, sale_state, observation, cliente) {
  const response = await axios.put(`${SALES_ENDPOINT}/${id}/state`, {
    sale_state,
    client_tax_condition_id: cliente.tax_condition,
    client_tax_condition_name: cliente.Tax_condition.name,
    observation
  })
  
  return response?.data?.data
}
